import React, { Fragment, useEffect, useState } from "react";
import Calpng from "../../assets/utils/images/Intagration image/cal.png";
import { cardData } from "./Constants";
import requestApiService from "../../services/requestApi.service";
import ShowIntegrationInfo from "./ShowIntDetails.js";

const Cal = (props) => {
    let { isInstalation, buttonValue, unInstall, name } = props;
    const [isConnected, setConnectionStatus] = useState(false);
    const [accountInfo, setAccountInfo] = useState([]);
    const [carddata, setData] = useState(cardData);
    let key = "";
    let foundData = carddata.find((data) => data.name === "cal.com");
    if (foundData) {
        key = foundData.name;
    }

    useEffect(() => {
        (async () => {
            await fetchCalAccountDetails();
        })();
    }, [buttonValue]);

    const fetchCalAccountDetails = async () => {
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "LOAD_INTEGRATIONS",
            TYPE: name,
        };
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let integrationInfo = response.data;
            if (integrationInfo.length > 0) {
                setConnectionStatus(true);
                const connectedInfo = JSON.parse(integrationInfo[0][2] || "{}");
                const { apiKey, calendarId, timezone } = connectedInfo.data || {};
                let IntegrationAccountInfo = [
                        { type: "id", id: integrationInfo[0][0] },
                        { type: "text", label: "API Key", value: apiKey },
                    ];
                setAccountInfo(IntegrationAccountInfo);
            } else {
                setAccountInfo([]);
                setConnectionStatus(false);
            }
        }
    };

    const onOpenModal = (type, openModule = false) => {
        isInstalation(type, openModule, "cal.com", "Calendar");
    };

    const integrationHeadData = {
        name: "Cal.com",
        tag: "Calendar",
        image: Calpng,
        installButtonText: "Install App",
        uninstallButtonText: "Uninstall App",
        testConnectionText: "Test Connection",
    };

    const integrationContent = [
        { heading: "Website", subheading: "https://cal.com", type: "url" },
        { heading: "Overview", subheading: "Integrate Cal.com with our AI Voice Agent to automate meeting scheduling and rescheduling during calls. Let the AI check availability, book appointments in real time, and keep your calendar organized—without any manual work.", type: "text" },
        { heading: "Key Benefits", subheading: [
            { 
                description: "AI agents can book, reschedule, or cancel meetings based on your real-time Cal.com availability.", 
                // description: "Free up valuable time by allowing our AI-powered agents to take over appointment bookings and rescheduling tasks. integrates with Cal.com to check real-time availability and instantly confirm bookings on your behalf." 
            },
            { 
                description: "Enable 24/7 appointment scheduling, even when your team is offline.", 
                // description: "Provide a smoother, faster experience by offering 24/7 booking capabilities. AI agents can assist customers anytime, checking availability and scheduling appointments within seconds." 
            },
            { 
                description: "Keep your Cal.com calendar automatically updated to avoid overlaps and double bookings.", 
                // description: "All appointments are automatically synced with your Cal.com calendar, ensuring you and your team have the latest information without needing manual updates." 
            },
            {
                description: "Deliver a seamless booking experience with instant confirmations and reminders.",
            }
        ], type: "list" }
    ];

    return (
        <Fragment>
            <div className="agent-details">
                <ShowIntegrationInfo
                    keyname={name}
                    headData={integrationHeadData}
                    integrationData={integrationContent}
                    isInstalled={buttonValue.includes(name)}
                    isConnected={isConnected}
                    accountInfo={accountInfo}
                    onInstall={onOpenModal}
                    onRemove={unInstall}
                />
            </div>
        </Fragment>
    );
};

export default Cal;
